export default "__VITE_ASSET__C1jt2XQK__"